import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Docket from '../../entities/docket';
import Task from '../../entities/task';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteDocket(): boolean {
return true;
}
export function collectDocketDeleteImpact(docket: Docket, context: DeleteImpactContext): void {
const key = 'docket:' + docket.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const taskDocketIdImpact = workingRows<Task>('task', findAll<Task>('tasks')).filter(taskRef => taskRef.docketId === docket.id);
taskDocketIdImpact.forEach(taskRef => addDeleteImpact(context, 'task:' + taskRef.id, 'tasks'));}
export function deleteImpactDocket(docket: Docket): DeleteImpact {
const context = deleteImpactContext();
collectDocketDeleteImpact(docket, context);
return deleteImpactCounts(context);
}
export function deleteDocket(docket: Docket, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteDocket()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectDocketDeleteImpact(docket, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || docket.id};
}
const key = 'docket:' + docket.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<Task>('task', [...store.getState().tasks.getMappingFor('docketId', docket.id)]).filter(taskTemp => taskTemp.docketId === docket.id).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
if (_task.status === 'D') return;
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.docketId === docket.id) {
_task.docketId = null;

}
_work.set('task:' + _task.id, _task);
dispatch(Actions.TaskActions.saveTaskQueue(_task), 'task:' + _task.id);
});
const deleted = docket.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.DocketActions.removeDocketQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceDocket(docket: Docket, replaceWith: Docket, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = docket.id;}
const _work = workingSet();
workingRows<Task>('task', [...store.getState().tasks.getMappingFor('docketId', docket.id)]).filter(taskTemp => taskTemp.docketId === docket.id).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
if (_task.status === 'D') return;
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.docketId === docket.id) {
_task.docketId = replaceWith.id;

}
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});



return docket;
}
